import { path } from 'ramda';

export const isValidExternalLink = (link) => {
  if (
    !link ||
    typeof link.href !== 'string' ||
    typeof link.label !== 'string' ||
    !link.label.trim()
  ) {
    return false;
  }
  if (!/^https?:\/\//i.test(link.href)) return false;

  const parsedLink = document.createElement('a');
  parsedLink.href = link.href;

  return (
    (parsedLink.protocol === 'http:' || parsedLink.protocol === 'https:') &&
    Boolean(parsedLink.hostname)
  );
};

/**
 * Resolves one configurable footer link against a segment.
 *
 * Returns a pair rather than a link, unlike getHelpLink, which collapses
 * suppression and malformed configuration into null. It can do that because an
 * unmatched card title has no default to fall back to; the footer always has
 * one, so "render nothing" and "render the built-in link" are distinct here.
 *
 * @param {Object} segment
 * @param {String} name
 * @returns {{render: Boolean, link: ?Object}}
 */
export const getFooterLink = (segment, name) => {
  const configuredLink = path(
    ['configuration', 'sangriaLayout', 'prepaidCard', 'footer', name],
    segment,
  );

  if (configuredLink === undefined) return { render: true, link: null };
  if (configuredLink === null) return { render: false, link: null };

  return isValidExternalLink(configuredLink)
    ? { render: true, link: configuredLink }
    : { render: true, link: null };
};
